import {
  InfiniteData,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import { GET_AUDIENCES_QUERY_KEY } from './useGetAudiences';

import AudiencesService, {
  AudienceResponse,
  UpdateAudienceDto,
} from '@/services/AudiencesService';

export function useUpdateAudience(audienceId: number) {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (updateAudienceDto: UpdateAudienceDto) =>
      AudiencesService.updateAudience(audienceId, updateAudienceDto),
    onMutate: () => {
      const previousData = queryClient.getQueryData<
        InfiniteData<AudienceResponse>
      >(GET_AUDIENCES_QUERY_KEY);
      return { previousData };
    },
    onError: (_error, _variables, context) => {
      if (context?.previousData) {
        queryClient.setQueryData(GET_AUDIENCES_QUERY_KEY, context.previousData);
      }
    },
    onSuccess: (data) => {
      queryClient.setQueryData<InfiniteData<AudienceResponse>>(
        GET_AUDIENCES_QUERY_KEY,
        (state) => {
          state?.pages?.forEach((page) =>
            page?.items.forEach((item) => {
              if (item.id === audienceId) {
                item.audiencePlatform.push(data);
              }

              return item;
            }),
          );

          return state;
        },
      );
    },
  });

  return {
    updateAudience: mutateAsync,
    isLoading: isPending,
  };
}
